import { useEffect, Children, cloneElement } from 'react'
import { connect } from 'react-redux'

import {
  getPaymentInfoGuestAction,
  getPaymentInfoMemberAction,
} from '../../actions/paymentInfoActions'
import { authenticatedSelector } from '../../reducers/userReducer'

function FetchPaymentInfo(props) {
  const { authenticated, paymentInfo, itemId, fetchPaymentInfo } = props

  useEffect(() => {
    if (itemId) {
      fetchPaymentInfo(authenticated, itemId)
    }
  }, [authenticated, itemId, fetchPaymentInfo])

  if (!paymentInfo) {
    return null
  }

  return Children.map(props.children, child =>
    cloneElement(child, {
      itemId,
      paymentInfo,
    }),
  )
}

export default connect(
  state => ({
    authenticated: authenticatedSelector(state.user),
    paymentInfo: state.buyer.paymentInfo,
  }),
  dispatch => ({
    fetchPaymentInfo(authenticated, itemId) {
      dispatch(
        authenticated
          ? getPaymentInfoMemberAction(itemId)
          : getPaymentInfoGuestAction(itemId),
      )
    },
  }),
)(FetchPaymentInfo)
